/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zesty_Spry_Gibbon_HintInputs */

const es_zesty_spry_gibbon_hint = /** @type {(inputs: Zesty_Spry_Gibbon_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir barco`)
};

const gl_zesty_spry_gibbon_hint = /** @type {(inputs: Zesty_Spry_Gibbon_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engadir barco`)
};

const en_zesty_spry_gibbon_hint = /** @type {(inputs: Zesty_Spry_Gibbon_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add boat`)
};

/**
* | output |
* | --- |
* | "Add boat" |
*
* @param {Zesty_Spry_Gibbon_HintInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const zesty_spry_gibbon_hint = /** @type {((inputs?: Zesty_Spry_Gibbon_HintInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zesty_Spry_Gibbon_HintInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_zesty_spry_gibbon_hint(inputs)
	if (locale === "en") return en_zesty_spry_gibbon_hint(inputs)
	return es_zesty_spry_gibbon_hint(inputs)
});